

// import React, { useState } from "react";
// import Datetime from "react-datetime";
// import moment from "moment";
// import "react-datetime/css/react-datetime.css";
// import bannerImage from '../assets/HomeImage.jpg'; // Import the image
// import "font-awesome/css/font-awesome.min.css"; // Import Font Awesome

// const Home = () => {
//   const [pickupDate, setPickupDate] = useState(null);
//   const [pickupTime, setPickupTime] = useState(null);
//   const [dropoffDate, setDropoffDate] = useState(null);
//   const [dropoffTime, setDropoffTime] = useState(null);

//   const today = moment();
//   const minDate = today.add(1, "days");

//   return (
//     <div
//       className="w-full h-[600px] bg-cover bg-center relative"
//       style={{ backgroundImage: `url(${bannerImage})` }}
//     >
//       {/* Overlay for dimming the background */}
//       <div className="absolute inset-0 bg-black bg-opacity-50"></div>

//       {/* Content Section */}
//       <div className="relative z-10 h-full flex flex-col md:flex-row items-center md:justify-between px-6 md:px-20">

//         {/* Left Section - Text */}
//         <div className="text-white max-w-xl text-center md:text-left order-1 md:order-none mb-6 md:mb-0">
//           <h1 className="text-3xl md:text-4xl font-bold mb-4 mt-6">
//             Rent A Self Drive Bike In Belagavi
//           </h1>
//         </div>

//         {/* Right Section - Booking Form */}
//         <div className="bg-white p-8 rounded-lg shadow-lg w-full md:w-auto order-2 md:order-none">
//           <div className="flex mb-6">
//             <button
//               className="w-1/2 px-4 bg-[#FF9630] text-white font-normal rounded-l-lg"
//             >
//               Daily Rentals
//             </button>
//             <button
//               className="w-1/2 px-4 bg-gray-200 text-gray-700 font-normal rounded-r-lg"
//             >
//               Monthly Subscription
//             </button>
//           </div>

//           <div className="space-y-4">
//             {/* Date and Time Fields */}
//             <div className="space-y-2 relative">
//               <div className="relative">
//                 <span className="absolute left-3 top-2  text-green-500">
//                   <i className="fa fa-calendar " aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat="MM/DD/YYYY"
//                   timeFormat={false}
//                   isValidDate={(current) => current.isAfter(minDate, "day")}
//                   onChange={(date) => setPickupDate(date)}
//                   className="form-control border border-gray-300 rounded-lg p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Pickup Date" }}
//                 />
//               </div>
//             </div>

//             <div className="space-y-2 relative">
//               <div className="relative">
//                 <span className="absolute left-3 top-2 text-green-500">
//                   <i className="fa fa-clock-o" aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat={false}
//                   timeFormat="hh:mm A"
//                   onChange={(time) => setPickupTime(time)}
//                   className="form-control border border-gray-300 rounded-lg p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Pickup Time" }}
//                 />
//               </div>
//             </div>

//             <div className="text-center text-gray-500">To</div>

//             <div className="space-y-2 relative">
//               <div className="relative">
//                 <span className="absolute left-3 top-2 text-red-500">
//                   <i className="fa fa-calendar" aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat="MM/DD/YYYY"
//                   timeFormat={false}
//                   isValidDate={(current) => current.isAfter(minDate, "day")}
//                   onChange={(date) => setDropoffDate(date)}
//                   className="form-control border border-gray-300 rounded-lg p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Dropoff Date" }}
//                 />
//               </div>
//             </div>

//             <div className="space-y-2 relative">
//               <div className="relative">
//                 <span className="absolute left-3 top-2 text-red-500">
//                   <i className="fa fa-clock-o" aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat={false}
//                   timeFormat="hh:mm A"
//                   onChange={(time) => setDropoffTime(time)}
//                   className="form-control border border-gray-300 rounded-lg p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Dropoff Time" }}
//                 />
//               </div>
//             </div>

//             <button className="w-full mt-4 py-2 bg-[#FF9630] text-white font-bold rounded-lg hover:bg-[#FF9630]">
//               Search
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Home;



// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom"; // Import useNavigate
// import Datetime from "react-datetime";
// import moment from "moment";
// import "react-datetime/css/react-datetime.css";
// import bannerImage from '../assets/HomeImage.jpg'; // Import the image
// import "font-awesome/css/font-awesome.min.css"; // Import Font Awesome

// const Home = () => {
//   const [pickupDate, setPickupDate] = useState(null);
//   const [pickupTime, setPickupTime] = useState(null);
//   const [dropoffDate, setDropoffDate] = useState(null);
//   const [dropoffTime, setDropoffTime] = useState(null);
//   const [rentalType, setRentalType] = useState("daily"); // Track selected rental type
//   const navigate = useNavigate();

//   const today = moment();
//   const minDate = today.add(1, "days");

//   const handleSearch = () => {
//     // Navigate to the appropriate component based on rentalType
//     if (rentalType === "daily") {
//       navigate("/daily-rental", {
//         state: { pickupDate, pickupTime, dropoffDate, dropoffTime },
//       });
//     } else if (rentalType === "monthly") {
//       navigate("/monthly-rental", {
//         state: { pickupDate, pickupTime, dropoffDate, dropoffTime },
//       });
//     }
//   };

//   return (
//     <div
//       className="w-full h-[600px] bg-cover bg-center relative"
//       style={{ backgroundImage: `url(${bannerImage})` }}
//     >
//       {/* Overlay for dimming the background */}
//       <div className="absolute inset-0 bg-black bg-opacity-50"></div>

//       {/* Content Section */}
//       <div className="relative z-10 h-full flex flex-col md:flex-row items-center md:justify-between px-6 md:px-20">

//         {/* Left Section - Text */}
//         <div className="text-white max-w-xl text-center md:text-left order-1 md:order-none mb-6 md:mb-0">
//           <h1 className="text-3xl md:text-4xl font-bold mb-4 mt-6">
//             Rent A Self Drive Bike In Belagavi
//           </h1>
//         </div>

//         {/* Right Section - Booking Form */}
//         <div className="bg-white p-8 rounded-lg shadow-lg w-full md:w-auto order-2 md:order-none">
//           <div className="flex mb-6">
//             <button
//               className={`w-1/2 px-4 ${
//                 rentalType === "daily" ? "bg-[#FF9630] text-white" : "bg-gray-200 text-gray-700"
//               } font-normal rounded-l-lg`}
//               onClick={() => setRentalType("daily")}
//             >
//               Daily Rentals
//             </button>
//             <button
//               className={`w-1/2 px-4 ${
//                 rentalType === "monthly" ? "bg-[#FF9630] text-white" : "bg-gray-200 text-gray-700"
//               } font-normal rounded-r-lg`}
//               onClick={() => setRentalType("monthly")}
//             >
//               Monthly Subscription
//             </button>
//           </div>

//           <div className="space-y-4">
//             {/* Date and Time Fields */}
//             <div className="space-y-2 relative">
//               <div className="relative">
//                 <span className="absolute left-3 top-2  text-green-500">
//                   <i className="fa fa-calendar " aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat="MM/DD/YYYY"
//                   timeFormat={false}
//                   isValidDate={(current) => current.isAfter(minDate, "day")}
//                   onChange={(date) => setPickupDate(date)}
//                   className="form-control border border-gray-300 rounded-lg p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Pickup Date" }}
//                 />
//               </div>
//             </div>

//             <div className="space-y-2 relative">
//               <div className="relative">
//                 <span className="absolute left-3 top-2 text-green-500">
//                   <i className="fa fa-clock-o" aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat={false}
//                   timeFormat="hh:mm A"
//                   onChange={(time) => setPickupTime(time)}
//                   className="form-control border border-gray-300 rounded-lg p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Pickup Time" }}
//                 />
//               </div>
//             </div>

//             <div className="text-center text-gray-500">To</div>

//             <div className="space-y-2 relative">
//               <div className="relative">
//                 <span className="absolute left-3 top-2 text-red-500">
//                   <i className="fa fa-calendar" aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat="MM/DD/YYYY"
//                   timeFormat={false}
//                   isValidDate={(current) => current.isAfter(minDate, "day")}
//                   onChange={(date) => setDropoffDate(date)}
//                   className="form-control border border-gray-300 rounded-lg p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Dropoff Date" }}
//                 />
//               </div>
//             </div>

//             <div className="space-y-2 relative">
//               <div className="relative">
//                 <span className="absolute left-3 top-2 text-red-500">
//                   <i className="fa fa-clock-o" aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat={false}
//                   timeFormat="hh:mm A"
//                   onChange={(time) => setDropoffTime(time)}
//                   className="form-control border border-gray-300 rounded-lg p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Dropoff Time" }}
//                 />
//               </div>
//             </div>

//             <button
//               className="w-full mt-4 py-2 bg-[#FF9630] text-white font-bold rounded-lg hover:bg-[#FF9630]"
//               onClick={handleSearch}
//             >
//               Search
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Home;



// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom"; // Import useNavigate
// import Datetime from "react-datetime";
// import moment from "moment";
// import "react-datetime/css/react-datetime.css";
// import bannerImage from "../assets/HomeImage.jpg"; // Import the image
// import "font-awesome/css/font-awesome.min.css"; // Import Font Awesome

// const Home = () => {
//   const [pickupDate, setPickupDate] = useState(null);
//   const [pickupTime, setPickupTime] = useState(null);
//   const [duration, setDuration] = useState(6); // Track duration for monthly subscription
//   const [rentalType, setRentalType] = useState("daily"); // Track selected rental type
//   const navigate = useNavigate();

//   const today = moment();
//   const minDate = today.add(1, "days");

//   const handleSearch = () => {
//     // Navigate to the appropriate component based on rentalType
//     if (rentalType === "daily") {
//       navigate("/daily-rental", { state: { pickupDate, pickupTime } });
//     } else if (rentalType === "monthly") {
//       navigate("/monthly-rental", { state: { pickupDate, pickupTime, duration } });
//     }
//   };

//   return (
//     <div
//       className="w-full h-[600px] bg-cover bg-center relative z-0"
//       style={{ backgroundImage: `url(${bannerImage})` }}
//     >
//       {/* Overlay for dimming the background */}
//       <div className="absolute inset-0 bg-black bg-opacity-50"></div>

//       {/* Content Section */}
//       <div className="relative z-10 h-full flex flex-col md:flex-row items-center md:justify-between px-6 md:px-20">
//         {/* Left Section - Text */}
//         <div className="text-white max-w-xl text-center md:text-left order-1 md:order-none mb-6 md:mb-0">
//           <h1 className="text-3xl md:text-4xl font-bold mb-4 mt-6">
//             Rent A Self Drive Bike In Belagavi
//           </h1>
//         </div>

//         {/* Right Section - Booking Form */}
//         <div className="bg-white p-8 rounded-lg shadow-lg w-full md:w-auto order-2 md:order-none">
//           {/* Rental Type Buttons */}
//           <div className="flex mb-6">
//             <button
//               className={`w-1/2 px-4 ${rentalType === "daily" ? "bg-[#FF9630] text-white" : "bg-[#A0A0A0] text-gray-700"
//                 } font-normal rounded-l-lg`}
//               onClick={() => setRentalType("daily")}
//             >
//               Daily Rentals
//             </button>
//             <button
//               className={`w-1/2 px-4 ${rentalType === "monthly" ? "bg-[#FF9630] text-white" : "bg-[#A0A0A0] text-white"
//                 } font-normal rounded-r-lg`}
//               onClick={() => setRentalType("monthly")}
//             >
//               Monthly Subscription
//             </button>
//           </div>

//           {/* Conditional Rendering Based on Rental Type */}
//           {rentalType === "daily" && (
//             <div className="space-y-4">
//               {/* Date and Time Fields for Daily Rental */}
//               <div className="relative">
//                 <span className="absolute left-3 top-2 text-green-500">
//                   <i className="fa fa-calendar" aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat="MM/DD/YYYY"
//                   timeFormat={false}
//                   isValidDate={(current) => current.isAfter(minDate, "day")}
//                   onChange={(date) => setPickupDate(date)}
//                   className="form-control border border-gray-300 rounded-2xl p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Pickup Date" }}
//                 />
//               </div>


//               <div className="relative">
//                 <span className="absolute left-3 top-2 text-green-500">
//                   <i className="fa fa-clock-o" aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat={false}
//                   timeFormat="hh:mm A"
//                   onChange={(time) => setPickupTime(time)}
//                   className="form-control border border-gray-300 rounded-2xl p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Pickup Time" }}
//                 />
//               </div>

//               <div className="text-center text-gray-500">To</div>

//               <div className="relative">
//                 <span className="absolute left-3 top-2 text-red-500">
//                   <i className="fa fa-calendar" aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat="MM/DD/YYYY"
//                   timeFormat={false}
//                   isValidDate={(current) => current.isAfter(minDate, "day")}
//                   onChange={(date) => setPickupDate(date)}
//                   className="form-control border border-gray-300 rounded-2xl p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Pickup Date" }}
//                 />
//               </div>


//               <div className="relative">
//                 <span className="absolute left-3 top-2 text-red-500">
//                   <i className="fa fa-clock-o" aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat={false}
//                   timeFormat="hh:mm A"
//                   onChange={(time) => setPickupTime(time)}
//                   className="form-control border border-gray-300 rounded-2xl p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Pickup Time" }}
//                 />
//               </div>
//             </div>


//           )}

//           {rentalType === "monthly" && (
//             <div className="space-y-6">
//               {/* Date Field for Monthly Subscription */}
//               <label className="block text-gray-700 font-semibold mb-2">
//                 Delivary Date
//               </label>
//               <div className="relative">
//                 <span className="absolute left-3 top-2 text-green-500">
//                   <i className="fa fa-calendar" aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat="MM/DD/YYYY"
//                   timeFormat={false}
//                   isValidDate={(current) => current.isAfter(minDate, "day")}
//                   onChange={(date) => setPickupDate(date)}
//                   className="form-control border border-gray-300 rounded-2xl p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Date" }}
//                 />
//               </div>

//               {/* Time Field for Monthly Subscription */}
//               <div className="relative">
//                 <span className="absolute left-3 top-2 text-green-500">
//                   <i className="fa fa-clock-o" aria-hidden="true"></i>
//                 </span>
//                 <Datetime
//                   dateFormat={false}
//                   timeFormat="hh:mm A"
//                   onChange={(time) => setPickupTime(time)}
//                   className="form-control border border-gray-300 rounded-2xl p-2 pl-10 w-full"
//                   inputProps={{ placeholder: "Choose Time" }}
//                 />
//               </div>

//               {/* Duration Selector */}
//               <div>
//                 <label className="block text-gray-700 font-semibold mb-2">
//                   Select Duration
//                 </label>
//                 <input
//                   type="range"
//                   min="2"
//                   max="12"
//                   value={duration}
//                   onChange={(e) => setDuration(e.target.value)}
//                   className="w-full"
//                 />
//                 <div className="flex justify-between text-sm text-gray-600 ">
//                   {[2, 4, 6, 8, 10, 12].map((number) => (
//                     <span key={number}>{number}</span>
//                   ))}
//                 </div>

//               </div>
//             </div>
//           )}

//           <button
//             className="w-full mt-6 py-2 bg-[#FF9630] text-white font-bold rounded-lg hover:bg-[#FF9630]"
//             onClick={handleSearch}
//           >
//             Search
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Home;




import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import Datetime from "react-datetime";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import bannerImage from "../assets/HomeImage.jpg"; // Import the image
import "font-awesome/css/font-awesome.min.css"; // Import Font Awesome

const Home = () => {
  const [pickupDate, setPickupDate] = useState(null);
  const [pickupTime, setPickupTime] = useState(null);
  const [duration, setDuration] = useState(6); // Track duration for monthly subscription
  const [rentalType, setRentalType] = useState("daily"); // Track selected rental type
  const navigate = useNavigate();

  const today = moment();
  const minDate = today.add(1, "days");


  const handleSearch = () => {
    const isMobile = window.innerWidth <= 768; // Define mobile view threshold
    if (isMobile) {
      if (rentalType === "daily") {
        navigate("/mobile-daily-rental", { state: { pickupDate, pickupTime } });
      } else if (rentalType === "monthly") {
        navigate("/mobile-monthly-rental", { state: { pickupDate, pickupTime, duration } });
      }
    } else {
      if (rentalType === "daily") {
        navigate("/daily-rental", { state: { pickupDate, pickupTime } });
      } else if (rentalType === "monthly") {
        navigate("/monthly-rental", { state: { pickupDate, pickupTime, duration } });
      }
    }
  };

  return (
    <div
      className="w-full md:h-[600px] h-[650px] bg-cover bg-center relative z-0"
      style={{ backgroundImage: `url(${bannerImage})` }}
    >
      {/* Overlay for dimming the background */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Content Section */}
      <div className="relative z-10 h-full flex flex-col md:flex-row items-center md:justify-between px-6 md:px-20">
        {/* Left Section - Text */}
        <div className="text-white max-w-xl text-center md:text-left order-1 md:order-none mb-6 md:mb-0">
          <h1 className="text-3xl md:text-4xl font-bold mb-4 mt-6">
            Rent A Self Drive Bike In Belagavi
          </h1>
        </div>

        {/* Right Section - Booking Form */}
        <div className="bg-white p-8 rounded-lg shadow-lg w-full md:w-auto order-2 md:order-none">
          {/* Rental Type Buttons */}
          <div className="flex mb-6">
            <button
              className={`w-1/2 px-4 ${rentalType === "daily" ? "bg-[#FF9630] text-white" : "bg-[#A0A0A0] text-gray-700"
                } font-normal rounded-l-lg`}
              onClick={() => setRentalType("daily")}
            >
              Daily Rentals
            </button>
            <button
              className={`w-1/2 px-4 ${rentalType === "monthly" ? "bg-[#FF9630] text-white" : "bg-[#A0A0A0] text-white"
                } font-normal rounded-r-lg`}
              onClick={() => setRentalType("monthly")}
            >
              Monthly Subscription
            </button>
          </div>

          {/* Conditional Rendering Based on Rental Type */}
          {rentalType === "daily" && (
            <div className="space-y-4">
              {/* Date and Time Fields for Daily Rental */}
              <div className="relative">
                <span className="absolute left-3 top-2 text-green-500">
                  <i className="fa fa-calendar" aria-hidden="true"></i>
                </span>
                <Datetime
                  dateFormat="MM/DD/YYYY"
                  timeFormat={false}
                  isValidDate={(current) => current.isAfter(minDate, "day")}
                  onChange={(date) => setPickupDate(date)}
                  className="form-control border border-gray-300 rounded-2xl p-2 pl-10 w-full"
                  inputProps={{ placeholder: "Choose Pickup Date" }}
                />
              </div>


              <div className="relative">
                <span className="absolute left-3 top-2 text-green-500">
                  <i className="fa fa-clock-o" aria-hidden="true"></i>
                </span>
                <Datetime
                  dateFormat={false}
                  timeFormat="hh:mm A"
                  onChange={(time) => setPickupTime(time)}
                  className="form-control border border-gray-300 rounded-2xl p-2 pl-10 w-full"
                  inputProps={{ placeholder: "Choose Pickup Time" }}
                />
              </div>

              <div className="text-center text-gray-500">To</div>

              <div className="relative">
                <span className="absolute left-3 top-2 text-red-500">
                  <i className="fa fa-calendar" aria-hidden="true"></i>
                </span>
                <Datetime
                  dateFormat="MM/DD/YYYY"
                  timeFormat={false}
                  isValidDate={(current) => current.isAfter(minDate, "day")}
                  onChange={(date) => setPickupDate(date)}
                  className="form-control border border-gray-300 rounded-2xl p-2 pl-10 w-full"
                  inputProps={{ placeholder: "Choose Pickup Date" }}
                />
              </div>


              <div className="relative">
                <span className="absolute left-3 top-2 text-red-500">
                  <i className="fa fa-clock-o" aria-hidden="true"></i>
                </span>
                <Datetime
                  dateFormat={false}
                  timeFormat="hh:mm A"
                  onChange={(time) => setPickupTime(time)}
                  className="form-control border border-gray-300 rounded-2xl p-2 pl-10 w-full"
                  inputProps={{ placeholder: "Choose Pickup Time" }}
                />
              </div>
            </div>


          )}

          {rentalType === "monthly" && (
            <div className="space-y-6">
              {/* Date Field for Monthly Subscription */}
              <label className="block text-gray-700 font-semibold mb-2">
                Delivary Date
              </label>
              <div className="relative">
                <span className="absolute left-3 top-2 text-green-500">
                  <i className="fa fa-calendar" aria-hidden="true"></i>
                </span>
                <Datetime
                  dateFormat="MM/DD/YYYY"
                  timeFormat={false}
                  isValidDate={(current) => current.isAfter(minDate, "day")}
                  onChange={(date) => setPickupDate(date)}
                  className="form-control border border-gray-300 rounded-2xl p-2 pl-10 w-full"
                  inputProps={{ placeholder: "Choose Date" }}
                />
              </div>

              {/* Time Field for Monthly Subscription */}
              <div className="relative">
                <span className="absolute left-3 top-2 text-green-500">
                  <i className="fa fa-clock-o" aria-hidden="true"></i>
                </span>
                <Datetime
                  dateFormat={false}
                  timeFormat="hh:mm A"
                  onChange={(time) => setPickupTime(time)}
                  className="form-control border border-gray-300 rounded-2xl p-2 pl-10 w-full"
                  inputProps={{ placeholder: "Choose Time" }}
                />
              </div>

              {/* Duration Selector */}
              <div>
                <label className="block text-gray-700 font-semibold mb-2">
                  Select Duration
                </label>
                <input
                  type="range"
                  min="2"
                  max="12"
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                  className="w-full"
                />
                <div className="flex justify-between text-sm text-gray-600 ">
                  {[2, 4, 6, 8, 10, 12].map((number) => (
                    <span key={number}>{number}</span>
                  ))}
                </div>

              </div>
            </div>
          )}

          <button
            className="w-full mt-6 py-2 bg-[#FF9630] text-white font-bold rounded-lg hover:bg-[#FF9630]"
            onClick={handleSearch}
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
  
};

export default Home;

